import { httpRequest } from "@services/http";

export interface CreateAudiencePayload {
  name: string;
  rules: Record<string, any>;
  audience_preset_id?: number;
}

export class CommandLinkAdsToAudience {
  async run(launchId: number, adGroupId: number, adIds: number[]) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/ads/`;
    await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify({ ad_ids: adIds }),
    });
    return;
  }
}
